# Configuring Apps

This section lists all currently installed CanvasPro Apps.

You can uninstall any apps that are no longer needed by clicking the uninstall button.
